export default __webpack_public_path__ + "static/media/sc32.8cefd009.mp4";